import "./about-section.scss";

const AboutSection = () => {
  return (
    <section className="about-section" id="about">
      <div className="about-section__headphones">
        <img src="/img/headphones_anim.gif" alt="headphones" />
      </div>
      <div className="about-section__content">
        <p>
          This website provides a free 24/7 streaming service, strictly dedicated to
          transcendent underground vibes, presenting you, the listener, with a tight
          non-mainstream hip-hop experience (both with and without accompanying vocals)
          for your listening pleasure.
        </p>
        <p>
          Your host is playing a large selection of funk, soul, jazz, and trip-hop, along
          with breakbeats and lots of turntable interpretations and sampling in an effort
          to point out that hip-hop is not just limited to rap or a single musical
          variation, but is rather a state of mind, deeply rooted in different types of
          music, some of which were already mentioned above, and others including blues,
          rock, and Jamaican sound systems culture.
        </p>
        <p>
          So, when somewhere along this continuous mix, you hear
        </p>
        <p className="about-section__content--highlight">
          The Incredible Bongo Band, or Ultramagnetic MC's, or Marlena Shaw, or Coldcut,
          or Donald Byrd and Dizzie Gillespie,
        </p>
        <p>
          you are listening to hip-hop at its finest, as exemplified by the incredible
          work of so many known and unknown DJs, producers, beat makers, and MCs, who
          pioneered this form of art and are the driving force behind its evolution.
        </p>
        <p className="about-section__content--dedication">
          This project is a dedication to all those artists, who made it possible.
        </p>
        <p>
          At times chill and mellow, at times heavy and conscious, the music you will hear
          bears the said attributes and is certainly not for everybody. But if you, like
          your host, are crazy about booming baselines, fat kicks, and crispy snares, with
          the occasional dope rhyme, we believe you will find great joy in tuning in.
        </p>
      </div>
      <div className="about-section__credits">
        <p>phatbeatz.online is a non-profit project driven by:</p>
        <p>Vibedigga aka Val Nice – Music Selection</p>
        <p>THVM – Web Design and Illustrations</p>
        <p>Clipper – Website Development</p>
      </div>
    </section>
  );
};

export default AboutSection;
